/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import __unplugin_components_0 from 'D:/项目/blueSkyReportForm/src/components/CNoData.vue';
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "preform-count-comprehensive"
};
var _hoisted_2 = {
  class: "preform-count-comprehensive-inner-content"
};
import { showToast } from 'vant';
import { EDateType } from '@/interface';
import { ROUTE_NAME } from '@/config/common';
import Overlay from '@/components/Overlay.vue';
import InfoCard from '@/views/components/InfoCard.vue';
import DataCell from '@/views/components/DataCell.vue';
import BaseEchart from '@/base-ui/echart/src/base-echart.vue';
import DataCellTabs from '@/views/components/DataCellTabs.vue';
import usePreformCountComprehensive from './hooks/usePreformCountComprehensive';
import DatePickerComprehensive from '@/components/DatePickerComprehensive/Index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup: function setup(__props) {
    var timeType = ref(EDateType.day);
    var baseEchartRef = ref();
    var router = useRouter();
    var _usePreformCountCompr = usePreformCountComprehensive(),
      trends = _usePreformCountCompr.trends,
      summary = _usePreformCountCompr.summary,
      ratioTabs = _usePreformCountCompr.ratioTabs,
      ratioUnits = _usePreformCountCompr.ratioUnits,
      summaryMap = _usePreformCountCompr.summaryMap,
      countLoading = _usePreformCountCompr.countLoading,
      ratioLoading = _usePreformCountCompr.ratioLoading,
      contrastData = _usePreformCountCompr.contrastData,
      trendsLoading = _usePreformCountCompr.trendsLoading,
      getPreformTrend = _usePreformCountCompr.getPreformTrend,
      getPreformContrast = _usePreformCountCompr.getPreformContrast,
      getPreformOrderReport = _usePreformCountCompr.getPreformOrderReport,
      getPreformReportTable = _usePreformCountCompr.getPreformReportTable;
    var ratioUnit = ref('吨');
    var showOverlay = ref(false);
    var ratioActive = ref('volume');
    var currentParams = reactive({
      startTime: _.stubString(),
      endTime: _.stubString()
    });
    var infoCardData = computed(function () {
      return _.map(summary.value, function (value, key) {
        return {
          value: value,
          label: summaryMap.value[key]
        };
      });
    });
    watch(ratioActive, handleRatioActive, {
      immediate: true
    });
    function handleRatioActive(value) {
      ratioUnit.value = ratioUnits[value];
    }
    function onClickTab(name) {
      if (_.eq(name, 'volume')) {
        console.log('name volume=>', name);
      } else if (_.eq(name, 'money')) {
        console.log('name money=>', name);
      } else {
        showToast('数据框标签页类型错误');
      }
      getPreformContrast(currentParams, ratioActive.value);
    }
    var confrimDate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('confrimDate data=>', params);
              _context.prev = 1;
              showOverlay.value = true;
              _.assign(currentParams, params);
              _context.next = 6;
              return getPreformOrderReport(params);
            case 6:
              _context.next = 8;
              return getPreformContrast(params, ratioActive.value);
            case 8:
              _context.next = 10;
              return getPreformTrend(params);
            case 10:
              _context.next = 12;
              return getPreformReportTable(params);
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              console.error('confrimDate e=>', _context.t0);
            case 17:
              _context.prev = 17;
              showOverlay.value = false;
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 14, 17, 20]]);
      }));
      return function confrimDate(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    // const switchClick = () => {
    //   if (params.value.type === 0) {
    //     window.location.href = `/table/guliaoSellDay.html?factoryId=${localCache.getItem(
    //       'factoryId'
    //     )}`;
    //   }
    //   if (params.value.type === 1) {
    //     window.location.href = `/table/guliaoSellWeek.html?factoryId=${localCache.getItem(
    //       'factoryId'
    //     )}`;
    //   }
    //   if (params.value.type === 2) {
    //     window.location.href = `/table/guliaoSellMonth.html?factoryId=${localCache.getItem(
    //       'factoryId'
    //     )}`;
    //   }
    // };
    var contrastOption = computed(function () {
      var data = _.map(contrastData.value, function (item) {
        return _.omit(item, 'ratio_num');
      });
      var unit = ratioUnit.value;
      return {
        series: [{
          type: 'pie',
          radius: [20, '40%'],
          data: data,
          // data: [
          //   { value: 1048, name: '机制砂' },
          //   { value: 735, name: '原石头' },
          //   { value: 580, name: '山顶洞' },
          //   { value: 484, name: '乌纱帽' }
          // ],
          emphasis: {
            disabled: true
          },
          label: {
            width: 110,
            minMargin: 0,
            alignTo: 'edge',
            lineHeight: 18,
            edgeDistance: 0,
            color: 'inherit',
            formatter: "{c}".concat(unit, " {d}%\n{name|{b}}"),
            rich: {
              name: {
                fontSize: 11,
                color: '#333'
              }
            }
          },
          labelLayout: function labelLayout(params) {
            var echartWidth = 0;
            if (baseEchartRef.value) {
              var _baseEchartRef$value$;
              echartWidth = (_baseEchartRef$value$ = baseEchartRef.value.getEchartWidth()) !== null && _baseEchartRef$value$ !== void 0 ? _baseEchartRef$value$ : 0;
            }
            var isLeft = params.labelRect.x < echartWidth / 2;
            var points = params.labelLinePoints;
            if (points) {
              points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
            }
            return {
              labelLinePoints: points
            };
          }
        }]
      };
    });
    var trendOption = computed(function () {
      var xdata = _.map(trends.value, function (item) {
        return item.name;
      });
      var sdata = _.map(trends.value, function (item) {
        return item.value;
      });
      return {
        xAxis: {
          type: 'category',
          axisLabel: {
            hideOverlap: false
          },
          // data: ['8:00', '10:00', '16:00']
          // data: ['09-26 6-8点', '09-26 8-10点', '09-26 10-16点']
          // data: ['2024-09-26 8:00', '2024-09-26 10:00', '2024-09-26 16:00']
          data: xdata
        },
        yAxis: {
          type: 'value',
          offset: -3
        },
        series: [{
          // data: [820, 932, 901],
          // data: [20, 32, 10],
          data: sdata,
          type: 'line',
          smooth: true
        }],
        tooltip: {
          trigger: 'axis',
          formatter: "{c}\u5428<br />{b}"
        }
      };
    });
    function viewDetails() {
      router.push({
        name: ROUTE_NAME.PREFORM_COUNT_RATIO_DETAILS,
        params: currentParams
      });
    }
    return function (_ctx, _cache) {
      var _component_van_button = _resolveComponent("van-button");
      var _component_c_no_data = __unplugin_components_0;
      var _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(DatePickerComprehensive, {
        showBtn: false,
        type: _unref(timeType),
        onConfirmDate: confrimDate
      }, {
        "bottom-extension": _withCtx(function () {
          return [_withDirectives(_createVNode(InfoCard, {
            data: _unref(infoCardData)
          }, null, 8, ["data"]), [[_directive_loading, _unref(countLoading)]])];
        }),
        _: 1
      }, 8, ["type"]), _createElementVNode("div", _hoisted_2, [_createVNode(DataCell, {
        cellTitle: "盘料各料类占比"
      }, {
        "data-cell-tabs": _withCtx(function () {
          return [_createVNode(DataCellTabs, {
            "type-tab": _unref(ratioTabs),
            modelValue: _unref(ratioActive),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(ratioActive) ? ratioActive.value = $event : null;
            }),
            onClickTab: onClickTab
          }, null, 8, ["type-tab", "modelValue"])];
        }),
        default: _withCtx(function () {
          return [_withDirectives(_createVNode(BaseEchart, {
            ref_key: "baseEchartRef",
            ref: baseEchartRef,
            options: _unref(contrastOption)
          }, null, 8, ["options"]), [[_directive_loading, _unref(ratioLoading)]]), _createVNode(_component_van_button, {
            plain: "",
            round: "",
            size: "small",
            onClick: viewDetails,
            class: "view-details-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("查看明细")];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(DataCell, {
        cellTitle: "各时段盘料趋势"
      }, {
        default: _withCtx(function () {
          return [_unref(trends).length ? _withDirectives((_openBlock(), _createBlock(BaseEchart, {
            key: 0,
            options: _unref(trendOption)
          }, null, 8, ["options"])), [[_directive_loading, _unref(trendsLoading)]]) : _withDirectives((_openBlock(), _createBlock(_component_c_no_data, {
            key: 1
          }, null, 512)), [[_directive_loading, _unref(trendsLoading)]])];
        }),
        _: 1
      })]), _createVNode(Overlay, {
        showOverlay: _unref(showOverlay)
      }, null, 8, ["showOverlay"])]);
    };
  }
});